// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.clickerAssessment.teacher.apis.proto (package geneo.lms.clickerAssessment.teacher.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { SessionModeEnum, SessionStatusEnum, TeacherAssessmentAttemptModeEnum, TeacherAssessmentSessionMetrics } from "@protos/learning_management/lms.db_pb";

/**
 * @generated from message geneo.lms.clickerAssessment.teacher.apis.CreateTeacherAssessmentSessionRequest
 */
export class CreateTeacherAssessmentSessionRequest extends Message<CreateTeacherAssessmentSessionRequest> {
  /**
   * ID of the teacher associated with the assessment session.
   *
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 assessment_id = 2;
   */
  assessmentId = 0;

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 3;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * Mode of the resource session (e.g., online, offline, etc.)
   *
   * @generated from field: geneo.lms.db.SessionModeEnum session_mode = 4;
   */
  sessionMode = SessionModeEnum.SESSION_MODE_UNDEFINED;

  /**
   * @generated from field: int64 connected_class_session_id = 5;
   */
  connectedClassSessionId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.db.TeacherAssessmentAttemptModeEnum teacher_assessment_attempt_mode = 6;
   */
  teacherAssessmentAttemptMode = TeacherAssessmentAttemptModeEnum.TEACHER_ASSESSMENT_ATTEMPT_MODE_UNDEFINED;

  constructor(data?: PartialMessage<CreateTeacherAssessmentSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.clickerAssessment.teacher.apis.CreateTeacherAssessmentSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 4, name: "session_mode", kind: "enum", T: proto3.getEnumType(SessionModeEnum) },
    { no: 5, name: "connected_class_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "teacher_assessment_attempt_mode", kind: "enum", T: proto3.getEnumType(TeacherAssessmentAttemptModeEnum) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTeacherAssessmentSessionRequest {
    return new CreateTeacherAssessmentSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTeacherAssessmentSessionRequest {
    return new CreateTeacherAssessmentSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTeacherAssessmentSessionRequest {
    return new CreateTeacherAssessmentSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTeacherAssessmentSessionRequest | PlainMessage<CreateTeacherAssessmentSessionRequest> | undefined, b: CreateTeacherAssessmentSessionRequest | PlainMessage<CreateTeacherAssessmentSessionRequest> | undefined): boolean {
    return proto3.util.equals(CreateTeacherAssessmentSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.clickerAssessment.teacher.apis.CreateTeacherAssessmentSessionResponse
 */
export class CreateTeacherAssessmentSessionResponse extends Message<CreateTeacherAssessmentSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: int64 teacher_assessment_session_id = 4;
   */
  teacherAssessmentSessionId = protoInt64.zero;

  constructor(data?: PartialMessage<CreateTeacherAssessmentSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.clickerAssessment.teacher.apis.CreateTeacherAssessmentSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "teacher_assessment_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTeacherAssessmentSessionResponse {
    return new CreateTeacherAssessmentSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTeacherAssessmentSessionResponse {
    return new CreateTeacherAssessmentSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTeacherAssessmentSessionResponse {
    return new CreateTeacherAssessmentSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTeacherAssessmentSessionResponse | PlainMessage<CreateTeacherAssessmentSessionResponse> | undefined, b: CreateTeacherAssessmentSessionResponse | PlainMessage<CreateTeacherAssessmentSessionResponse> | undefined): boolean {
    return proto3.util.equals(CreateTeacherAssessmentSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.clickerAssessment.teacher.apis.UpdateTeacherAssessmentSessionRequest
 */
export class UpdateTeacherAssessmentSessionRequest extends Message<UpdateTeacherAssessmentSessionRequest> {
  /**
   * Unique identifier for the teacher's assessment session.
   *
   * @generated from field: int64 teacher_assessment_session_id = 1;
   */
  teacherAssessmentSessionId = protoInt64.zero;

  /**
   * ID of the student associated with the assessment session.
   *
   * @generated from field: int64 teacher_id = 2;
   */
  teacherId = protoInt64.zero;

  /**
   * ID of the assessment associated with the session.
   *
   * @generated from field: int32 assessment_id = 3;
   */
  assessmentId = 0;

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 4;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: repeated string completed_question_ids = 5;
   */
  completedQuestionIds: string[] = [];

  /**
   * optional geneo.lms.db.TeacherAssessmentSessionMetrics metrics = 7;
   *
   * @generated from field: repeated string visited_question_ids = 6;
   */
  visitedQuestionIds: string[] = [];

  constructor(data?: PartialMessage<UpdateTeacherAssessmentSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.clickerAssessment.teacher.apis.UpdateTeacherAssessmentSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_assessment_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 5, name: "completed_question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "visited_question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateTeacherAssessmentSessionRequest {
    return new UpdateTeacherAssessmentSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateTeacherAssessmentSessionRequest {
    return new UpdateTeacherAssessmentSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateTeacherAssessmentSessionRequest {
    return new UpdateTeacherAssessmentSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateTeacherAssessmentSessionRequest | PlainMessage<UpdateTeacherAssessmentSessionRequest> | undefined, b: UpdateTeacherAssessmentSessionRequest | PlainMessage<UpdateTeacherAssessmentSessionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateTeacherAssessmentSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.clickerAssessment.teacher.apis.UpdateTeacherAssessmentSessionResponse
 */
export class UpdateTeacherAssessmentSessionResponse extends Message<UpdateTeacherAssessmentSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: int64 teacher_assessment_session_id = 4;
   */
  teacherAssessmentSessionId = protoInt64.zero;

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 5;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  constructor(data?: PartialMessage<UpdateTeacherAssessmentSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.clickerAssessment.teacher.apis.UpdateTeacherAssessmentSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "teacher_assessment_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateTeacherAssessmentSessionResponse {
    return new UpdateTeacherAssessmentSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateTeacherAssessmentSessionResponse {
    return new UpdateTeacherAssessmentSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateTeacherAssessmentSessionResponse {
    return new UpdateTeacherAssessmentSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateTeacherAssessmentSessionResponse | PlainMessage<UpdateTeacherAssessmentSessionResponse> | undefined, b: UpdateTeacherAssessmentSessionResponse | PlainMessage<UpdateTeacherAssessmentSessionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateTeacherAssessmentSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.clickerAssessment.teacher.apis.GetTeacherPreviousAssessmentSessionRequest
 */
export class GetTeacherPreviousAssessmentSessionRequest extends Message<GetTeacherPreviousAssessmentSessionRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 assessment_id = 2;
   */
  assessmentId = 0;

  constructor(data?: PartialMessage<GetTeacherPreviousAssessmentSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.clickerAssessment.teacher.apis.GetTeacherPreviousAssessmentSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeacherPreviousAssessmentSessionRequest {
    return new GetTeacherPreviousAssessmentSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeacherPreviousAssessmentSessionRequest {
    return new GetTeacherPreviousAssessmentSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeacherPreviousAssessmentSessionRequest {
    return new GetTeacherPreviousAssessmentSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeacherPreviousAssessmentSessionRequest | PlainMessage<GetTeacherPreviousAssessmentSessionRequest> | undefined, b: GetTeacherPreviousAssessmentSessionRequest | PlainMessage<GetTeacherPreviousAssessmentSessionRequest> | undefined): boolean {
    return proto3.util.equals(GetTeacherPreviousAssessmentSessionRequest, a, b);
  }
}

/**
 * Response message containing previous assessment session data
 *
 * @generated from message geneo.lms.clickerAssessment.teacher.apis.GetTeacherPreviousAssessmentSessionResponse
 */
export class GetTeacherPreviousAssessmentSessionResponse extends Message<GetTeacherPreviousAssessmentSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.lms.clickerAssessment.teacher.apis.TeacherPreviousAssessmentSession data = 4;
   */
  data?: TeacherPreviousAssessmentSession;

  constructor(data?: PartialMessage<GetTeacherPreviousAssessmentSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.clickerAssessment.teacher.apis.GetTeacherPreviousAssessmentSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherPreviousAssessmentSession, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTeacherPreviousAssessmentSessionResponse {
    return new GetTeacherPreviousAssessmentSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTeacherPreviousAssessmentSessionResponse {
    return new GetTeacherPreviousAssessmentSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTeacherPreviousAssessmentSessionResponse {
    return new GetTeacherPreviousAssessmentSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTeacherPreviousAssessmentSessionResponse | PlainMessage<GetTeacherPreviousAssessmentSessionResponse> | undefined, b: GetTeacherPreviousAssessmentSessionResponse | PlainMessage<GetTeacherPreviousAssessmentSessionResponse> | undefined): boolean {
    return proto3.util.equals(GetTeacherPreviousAssessmentSessionResponse, a, b);
  }
}

/**
 * Teacher's previous assessment session data
 *
 * @generated from message geneo.lms.clickerAssessment.teacher.apis.TeacherPreviousAssessmentSession
 */
export class TeacherPreviousAssessmentSession extends Message<TeacherPreviousAssessmentSession> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int32 assessment_id = 2;
   */
  assessmentId = 0;

  /**
   * Full previous session metrics
   *
   * @generated from field: optional geneo.lms.db.TeacherAssessmentSessionMetrics previous_metrics = 3;
   */
  previousMetrics?: TeacherAssessmentSessionMetrics;

  /**
   * @generated from field: geneo.lms.db.SessionStatusEnum session_status = 4;
   */
  sessionStatus = SessionStatusEnum.SESSION_STATUS_UNDEFINED;

  /**
   * @generated from field: repeated string completed_question_ids = 5;
   */
  completedQuestionIds: string[] = [];

  /**
   * @generated from field: repeated string visited_question_ids = 6;
   */
  visitedQuestionIds: string[] = [];

  /**
   * @generated from field: repeated geneo.lms.clickerAssessment.teacher.apis.SessionQuestionActivityInfo completed_questions_info = 7;
   */
  completedQuestionsInfo: SessionQuestionActivityInfo[] = [];

  constructor(data?: PartialMessage<TeacherPreviousAssessmentSession>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.clickerAssessment.teacher.apis.TeacherPreviousAssessmentSession";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "previous_metrics", kind: "message", T: TeacherAssessmentSessionMetrics, opt: true },
    { no: 4, name: "session_status", kind: "enum", T: proto3.getEnumType(SessionStatusEnum) },
    { no: 5, name: "completed_question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "visited_question_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "completed_questions_info", kind: "message", T: SessionQuestionActivityInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherPreviousAssessmentSession {
    return new TeacherPreviousAssessmentSession().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherPreviousAssessmentSession {
    return new TeacherPreviousAssessmentSession().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherPreviousAssessmentSession {
    return new TeacherPreviousAssessmentSession().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherPreviousAssessmentSession | PlainMessage<TeacherPreviousAssessmentSession> | undefined, b: TeacherPreviousAssessmentSession | PlainMessage<TeacherPreviousAssessmentSession> | undefined): boolean {
    return proto3.util.equals(TeacherPreviousAssessmentSession, a, b);
  }
}

/**
 * @generated from message geneo.lms.clickerAssessment.teacher.apis.SessionQuestionActivityInfo
 */
export class SessionQuestionActivityInfo extends Message<SessionQuestionActivityInfo> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: int32 teacher_assessment_session_id = 2;
   */
  teacherAssessmentSessionId = 0;

  /**
   * @generated from field: int32 connected_class_session_id = 3;
   */
  connectedClassSessionId = 0;

  /**
   * @generated from field: int32 question_session_id = 4;
   */
  questionSessionId = 0;

  /**
   * @generated from field: bool is_visited = 5;
   */
  isVisited = false;

  /**
   * @generated from field: bool is_completed = 6;
   */
  isCompleted = false;

  /**
   * @generated from field: float time_spent_in_min = 7;
   */
  timeSpentInMin = 0;

  constructor(data?: PartialMessage<SessionQuestionActivityInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.clickerAssessment.teacher.apis.SessionQuestionActivityInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "teacher_assessment_session_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "connected_class_session_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "question_session_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "is_visited", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "time_spent_in_min", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionQuestionActivityInfo {
    return new SessionQuestionActivityInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionQuestionActivityInfo {
    return new SessionQuestionActivityInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionQuestionActivityInfo {
    return new SessionQuestionActivityInfo().fromJsonString(jsonString, options);
  }

  static equals(a: SessionQuestionActivityInfo | PlainMessage<SessionQuestionActivityInfo> | undefined, b: SessionQuestionActivityInfo | PlainMessage<SessionQuestionActivityInfo> | undefined): boolean {
    return proto3.util.equals(SessionQuestionActivityInfo, a, b);
  }
}

